import { store } from '../store/store';

const deleteUser = async (itemId) => {
  const state = store.getState();
  const token = state.user.currentUser.token;
  const API_BASE = state.user.apiBase;

  try {
    const response = await fetch(`${API_BASE}/users/${itemId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Handle 204 No Content or empty bodies
    const contentType = response.headers.get("content-type");
    if (response.status === 204 || !contentType || !contentType.includes("application/json")) {
      return { success: true };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting item:", error);
    throw error;
  }
};

export default deleteUser;

//api.DELETE("/users/:id",